/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "काल",
        "0": "आज",
        "1": "उद्या",
        "future": {
          "one": "येत्या {0} दिवसामध्ये",
          "other": "येत्या {0} दिवसांमध्ये"
        },
        "past": {
          "one": "{0} दिवसापूर्वी",
          "other": "{0} दिवसांपूर्वी"
        }
      },
      "day-narrow": {
        "-1": "काल",
        "0": "आज",
        "1": "उद्या",
        "future": {
          "one": "{0} दिवसामध्ये",
          "other": "{0} दिवसांमध्ये"
        },
        "past": {
          "one": "{0} दिवसापूर्वी",
          "other": "{0} दिवसांपूर्वी"
        }
      },
      "day-short": {
        "-1": "काल",
        "0": "आज",
        "1": "उद्या",
        "future": {
          "one": "{0} दिवसामध्ये",
          "other": "येत्या {0} दिवसांमध्ये"
        },
        "past": {
          "one": "{0} दिवसापूर्वी",
          "other": "{0} दिवसांपूर्वी"
        }
      },
      "hour": {
        "0": "तासात",
        "future": {
          "one": "{0} तासामध्ये",
          "other": "{0} तासांमध्ये"
        },
        "past": {
          "one": "{0} तासापूर्वी",
          "other": "{0} तासांपूर्वी"
        }
      },
      "hour-narrow": {
        "0": "तासात",
        "future": {
          "one": "येत्या {0} तासामध्ये",
          "other": "येत्या {0} तासांमध्ये"
        },
        "past": {
          "one": "{0} तासापूर्वी",
          "other": "{0} तासांपूर्वी"
        }
      },
      "hour-short": {
        "0": "तासात",
        "future": {
          "one": "{0} तासामध्ये",
          "other": "{0} तासांमध्ये"
        },
        "past": {
          "one": "{0} तासापूर्वी",
          "other": "{0} तासांपूर्वी"
        }
      },
      "minute": {
        "0": "या मिनिटात",
        "future": {
          "one": "{0} मिनिटामध्ये",
          "other": "{0} मिनिटांमध्ये"
        },
        "past": {
          "one": "{0} मिनिटापूर्वी",
          "other": "{0} मिनिटांपूर्वी"
        }
      },
      "minute-narrow": {
        "0": "या मिनिटात",
        "future": {
          "one": "{0} मिनि. मध्ये",
          "other": "{0} मिनि. मध्ये"
        },
        "past": {
          "one": "{0} मिनि. पूर्वी",
          "other": "{0} मिनि. पूर्वी"
        }
      },
      "minute-short": {
        "0": "या मिनिटात",
        "future": {
          "one": "{0} मिनि. मध्ये",
          "other": "{0} मिनि. मध्ये"
        },
        "past": {
          "one": "{0} मिनि. पूर्वी",
          "other": "{0} मिनि. पूर्वी"
        }
      },
      "month": {
        "-1": "मागील महिना",
        "0": "हा महिना",
        "1": "पुढील महिना",
        "future": {
          "one": "येत्या {0} महिन्यामध्ये",
          "other": "येत्या {0} महिन्यांमध्ये"
        },
        "past": {
          "one": "{0} महिन्यापूर्वी",
          "other": "{0} महिन्यांपूर्वी"
        }
      },
      "month-narrow": {
        "-1": "मागील महिना",
        "0": "हा महिना",
        "1": "पुढील महिना",
        "future": {
          "one": "{0} महिन्यामध्ये",
          "other": "{0} महिन्यांमध्ये"
        },
        "past": {
          "one": "{0} महिन्यापूर्वी",
          "other": "{0} महिन्यांपूर्वी"
        }
      },
      "month-short": {
        "-1": "मागील महिना",
        "0": "हा महिना",
        "1": "पुढील महिना",
        "future": {
          "one": "{0} महिन्यामध्ये",
          "other": "{0} महिन्यामध्ये"
        },
        "past": {
          "one": "{0} महिन्यापूर्वी",
          "other": "{0} महिन्यांपूर्वी"
        }
      },
      "nu": ["deva"],
      "quarter": {
        "-1": "मागील तिमाही",
        "0": "ही तिमाही",
        "1": "पुढील तिमाही",
        "future": {
          "one": "{0} तिमाहीमध्ये",
          "other": "{0} तिमाहींमध्ये"
        },
        "past": {
          "one": "{0} तिमाहीपूर्वी",
          "other": "{0} तिमाहींपूर्वी"
        }
      },
      "quarter-narrow": {
        "-1": "मागील तिमाही",
        "0": "ही तिमाही",
        "1": "पुढील तिमाही",
        "future": {
          "one": "{0} तिमाहीमध्ये",
          "other": "{0} तिमाहींमध्ये"
        },
        "past": {
          "one": "{0} तिमाहीपूर्वी",
          "other": "{0} तिमाहींपूर्वी"
        }
      },
      "quarter-short": {
        "-1": "मागील तिमाही",
        "0": "ही तिमाही",
        "1": "पुढील तिमाही",
        "future": {
          "one": "येत्या {0} तिमाहीमध्ये",
          "other": "येत्या {0} तिमाहींमध्ये"
        },
        "past": {
          "one": "{0} तिमाहीपूर्वी",
          "other": "{0} तिमाहींपूर्वी"
        }
      },
      "second": {
        "0": "आत्ता",
        "future": {
          "one": "{0} सेकंदामध्ये",
          "other": "{0} सेकंदांमध्ये"
        },
        "past": {
          "one": "{0} सेकंदापूर्वी",
          "other": "{0} सेकंदांपूर्वी"
        }
      },
      "second-narrow": {
        "0": "आत्ता",
        "future": {
          "one": "{0} से. मध्ये",
          "other": "येत्या {0} से. मध्ये"
        },
        "past": {
          "one": "{0} से. पूर्वी",
          "other": "{0} से. पूर्वी"
        }
      },
      "second-short": {
        "0": "आत्ता",
        "future": {
          "one": "{0} से. मध्ये",
          "other": "{0} से. मध्ये"
        },
        "past": {
          "one": "{0} से. पूर्वी",
          "other": "{0} से. पूर्वी"
        }
      },
      "week": {
        "-1": "मागील आठवडा",
        "0": "हा आठवडा",
        "1": "पुढील आठवडा",
        "future": {
          "one": "{0} आठवड्यामध्ये",
          "other": "{0} आठवड्यांमध्ये"
        },
        "past": {
          "one": "{0} आठवड्यापूर्वी",
          "other": "{0} आठवड्यांपूर्वी"
        }
      },
      "week-narrow": {
        "-1": "मागील आठवडा",
        "0": "हा आठवडा",
        "1": "पुढील आठवडा",
        "future": {
          "one": "येत्या {0} आठवड्यामध्ये",
          "other": "येत्या {0} आठवड्यांमध्ये"
        },
        "past": {
          "one": "{0} आठवड्यापूर्वी",
          "other": "{0} आठवड्यांपूर्वी"
        }
      },
      "week-short": {
        "-1": "मागील आठवडा",
        "0": "हा आठवडा",
        "1": "पुढील आठवडा",
        "future": {
          "one": "येत्या {0} आठवड्यामध्ये",
          "other": "येत्या {0} आठवड्यांमध्ये"
        },
        "past": {
          "one": "{0} आठवड्यापूर्वी",
          "other": "{0} आठवड्यांपूर्वी"
        }
      },
      "year": {
        "-1": "मागील वर्ष",
        "0": "हे वर्ष",
        "1": "पुढील वर्ष",
        "future": {
          "one": "येत्या {0} वर्षामध्ये",
          "other": "येत्या {0} वर्षांमध्ये"
        },
        "past": {
          "one": "{0} वर्षापूर्वी",
          "other": "{0} वर्षांपूर्वी"
        }
      },
      "year-narrow": {
        "-1": "मागील वर्ष",
        "0": "हे वर्ष",
        "1": "पुढील वर्ष",
        "future": {
          "one": "येत्या {0} वर्षामध्ये",
          "other": "येत्या {0} वर्षांमध्ये"
        },
        "past": {
          "one": "{0} वर्षापूर्वी",
          "other": "{0} वर्षांपूर्वी"
        }
      },
      "year-short": {
        "-1": "मागील वर्ष",
        "0": "हे वर्ष",
        "1": "पुढील वर्ष",
        "future": {
          "one": "{0} वर्षामध्ये",
          "other": "{0} वर्षांमध्ये"
        },
        "past": {
          "one": "{0} वर्षापूर्वी",
          "other": "{0} वर्षांपूर्वी"
        }
      }
    },
    "locale": "mr"
  });
}